import { create } from 'zustand';

export type UIPanel = 'inventory' | 'skill' | 'quest' | 'mail' | 'shop' | 'guild' | 'chat' | 'minimap' | 'menu' | 'npcDialog' | 'stat' | 'teleport' | 'admin' | 'pet' | 'settings' | 'friend' | 'party' | 'trade' | 'storage';

export interface NpcDialogData {
  id: string;
  name: string;
  role: string;
  dialog: string;
}

interface UIState {
  open: Record<UIPanel, boolean>;
  npcDialog: NpcDialogData | null;
  toast: { id: number; text: string; level: 'info' | 'warn' | 'error' } | null;
  buffRefreshTick: number;
  toggle: (p: UIPanel) => void;
  set: (p: UIPanel, v: boolean) => void;
  openNpcDialog: (data: NpcDialogData) => void;
  closeNpcDialog: () => void;
  showToast: (text: string, level?: 'info' | 'warn' | 'error') => void;
  bumpBuffRefresh: () => void;
}

let toastId = 0;

export const useUIStore = create<UIState>((set) => ({
  open: {
    inventory: false, skill: false, quest: false, mail: false,
    shop: false, guild: false, chat: true, minimap: true, menu: false, npcDialog: false, stat: false, teleport: false, admin: false, pet: false, settings: false, friend: false, party: false, trade: false, storage: false,
  },
  npcDialog: null,
  toast: null,
  buffRefreshTick: 0,
  toggle: (p) => set((s) => ({ open: { ...s.open, [p]: !s.open[p] } })),
  set: (p, v) => set((s) => ({ open: { ...s.open, [p]: v } })),
  openNpcDialog: (data) => set((s) => ({ npcDialog: data, open: { ...s.open, npcDialog: true } })),
  closeNpcDialog: () => set((s) => ({ npcDialog: null, open: { ...s.open, npcDialog: false } })),
  bumpBuffRefresh: () => set((s) => ({ buffRefreshTick: s.buffRefreshTick + 1 })),
  showToast: (text, level = 'info') => {
    const id = ++toastId;
    set({ toast: { id, text, level } });
    setTimeout(() => {
      set((s) => (s.toast?.id === id ? { toast: null } : s));
    }, 3000);
  },
}));
